export default "__VITE_ASSET__44c39c03__"